export default __webpack_public_path__ + "static/media/EmptyCircleTick.7bf7e0a5.svg";